module.exports = __webpack_public_path__ + "static/media/ftmscan-logo.fd869362.svg";